import { useSearch } from "@tanstack/react-location";
import { useEffect } from "react";

import { useAvailablePools } from "../../../hooks/useAvailablePools";
import { TLocationGenerics } from "../../../pages/routes";
import { OrderActions } from "../actions";
import { useOrderContext } from "../context";

export const useActivePool = () => {
  const { state, dispatch } = useOrderContext();
  const { given, taken } = useSearch<TLocationGenerics>();
  const activeGiven = state.flowData.syncSearch ? given : state.assets?.given?.metadata?.assetId;
  const activeTaken = state.flowData.syncSearch ? taken : state.assets?.taken?.metadata?.assetId;

  const { availablePools, isLoading } = useAvailablePools({
    givenAssetId: activeGiven,
    takenAssetId: activeTaken,
  });

  useEffect(() => {
    if (!state.flowData.syncPool) {
      return;
    }

    OrderActions.setFetchingPool(isLoading, dispatch, "OrderContext.useActivePool.isLoading");
  }, [isLoading, state.flowData.syncPool]);

  useEffect(() => {
    if (
      isLoading ||
      activeGiven === undefined ||
      activeTaken === undefined ||
      !state.flowData.syncPool
    ) {
      return;
    }

    if (availablePools?.length === 0) {
      return OrderActions.unsetPool(dispatch, "OrderContext.useActivePool.noPools");
    }

    if (availablePools?.[0]) {
      OrderActions.setPool(availablePools[0], dispatch, "OrderContext.useActivePool.firstPool");
    }
  }, [isLoading, availablePools, activeGiven, activeTaken, state.flowData.syncPool]);
};
